import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';

import api from './api';
import oauth from './oauth';
import application from './application';

export default () =>
    combineReducers({
        api,
        application,
        oauth,
        router: routerReducer,
    });
